/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M16 12V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V12"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M20 12V9.4C20 7.15979 20 6.03968 19.564 5.18404C19.1805 4.43139 18.5686 3.81947 17.816 3.43597C16.9603 3 15.8402 3 13.6 3H10.4C8.15979 3 7.03968 3 6.18404 3.43597C5.43139 3.81947 4.81947 4.43139 4.43597 5.18404C4 6.03968 4 7.15979 4 9.4V12M2 15V21M22 15V21M22 19V15.2C22 14.0799 22 13.5198 21.782 13.092C21.5903 12.7157 21.2843 12.4097 20.908 12.218C20.4802 12 19.9201 12 18.8 12H5.2C4.07989 12 3.51984 12 3.09202 12.218C2.71569 12.4097 2.40973 12.7157 2.21799 13.092C2 13.5198 2 14.0799 2 15.2V19H22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				opacity="0.12"
				d="M2 15.2C2 14.0799 2 13.5198 2.21799 13.092C2.40973 12.7157 2.71569 12.4097 3.09202 12.218C3.51984 12 4.0799 12 5.2 12H18.8C19.9201 12 20.4802 12 20.908 12.218C21.2843 12.4097 21.5903 12.7157 21.782 13.092C22 13.5198 22 14.0799 22 15.2V19H2V15.2Z"
				fill="currentColor"
			/>
			<path
				d="M20 12V9.4C20 7.15979 20 6.03968 19.564 5.18404C19.1805 4.43139 18.5686 3.81947 17.816 3.43597C16.9603 3 15.8402 3 13.6 3H10.4C8.15979 3 7.03968 3 6.18404 3.43597C5.43139 3.81947 4.81947 4.43139 4.43597 5.18404C4 6.03968 4 7.15979 4 9.4V12M2 15V21M22 15V21M16 12V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V12M22 19V15.2C22 14.0799 22 13.5198 21.782 13.092C21.5903 12.7157 21.2843 12.4097 20.908 12.218C20.4802 12 19.9201 12 18.8 12H5.2C4.07989 12 3.51984 12 3.09202 12.218C2.71569 12.4097 2.40973 12.7157 2.21799 13.092C2 13.5198 2 14.0799 2 15.2V19H22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M9.65 2.25C7.40979 2.25 6.28968 2.25 5.43404 2.68597C4.68139 3.06947 4.06947 3.68139 3.68597 4.43404C3.25 5.28969 3.25 6.40979 3.25 8.65V10.45C3.25 10.73 3.25 10.87 3.3045 10.977C3.35243 11.0711 3.42892 11.1476 3.523 11.1955C3.62996 11.25 3.76997 11.25 4.05 11.25H7.2C7.48003 11.25 7.62004 11.25 7.727 11.1955C7.82108 11.1476 7.89757 11.0711 7.9455 10.977C8 10.87 8 10.73 8 10.45V10.2C8 9.0799 8 8.51984 8.21799 8.09202C8.40973 7.71569 8.71569 7.40973 9.09202 7.21799C9.51984 7 10.0799 7 11.2 7H12.8C13.9201 7 14.4802 7 14.908 7.21799C15.2843 7.40973 15.5903 7.71569 15.782 8.09202C16 8.51984 16 9.0799 16 10.2V10.45C16 10.73 16 10.87 16.0545 10.977C16.1024 11.0711 16.1789 11.1476 16.273 11.1955C16.38 11.25 16.52 11.25 16.8 11.25H19.95C20.23 11.25 20.37 11.25 20.477 11.1955C20.5711 11.1476 20.6476 11.0711 20.6955 10.977C20.75 10.87 20.75 10.73 20.75 10.45V8.65C20.75 6.40979 20.75 5.28969 20.314 4.43404C19.9305 3.68139 19.3186 3.06947 18.566 2.68597C17.7103 2.25 16.5902 2.25 14.35 2.25H9.65Z"
				fill="currentColor"
			/>
			<path
				d="M1.25 15.45C1.25 14.3299 1.25 13.7698 1.46799 13.342C1.65973 12.9657 1.96569 12.6597 2.34202 12.468C2.76984 12.25 3.3299 12.25 4.45 12.25H19.55C20.6701 12.25 21.2302 12.25 21.658 12.468C22.0343 12.6597 22.3403 12.9657 22.532 13.342C22.75 13.7698 22.75 14.3299 22.75 15.45V21.25C22.75 21.6642 22.4142 22 22 22C21.5858 22 21.25 21.6642 21.25 21.25V20.2C21.25 19.9515 21.0485 19.75 20.8 19.75H3.2C2.95147 19.75 2.75 19.9515 2.75 20.2V21.25C2.75 21.6642 2.41421 22 2 22C1.58579 22 1.25 21.6642 1.25 21.25V15.45Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M4 12V9.4C4 7.15979 4 6.03968 4.43597 5.18404C4.81947 4.43139 5.43139 3.81947 6.18404 3.43597C7.03968 3 8.15979 3 10.4 3H14.5C15.8956 3 16.5933 3 17.1611 3.17224C18.4395 3.56004 19.44 4.56046 19.8278 5.83886C20 6.40666 20 7.10444 20 8.5V8.5V9M2 15V21M22 15V21M16 12V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V12M2 19V15.2C2 14.0799 2 13.5198 2.21799 13.092C2.40973 12.7157 2.71569 12.4097 3.09202 12.218C3.51984 12 4.07989 12 5.2 12H18.8C19.9201 12 20.4802 12 20.908 12.218C21.2843 12.4097 21.5903 12.7157 21.782 13.092C22 13.5198 22 14.0799 22 15.2V19H5.5"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M20 12V9.4C20 7.15979 20 6.03968 19.564 5.18404C19.1805 4.43139 18.5686 3.81947 17.816 3.43597C16.9603 3 15.8402 3 13.6 3H10.4C8.15979 3 7.03968 3 6.18404 3.43597C5.43139 3.81947 4.81947 4.43139 4.43597 5.18404C4 6.03968 4 7.15979 4 9.4V12M2 15V21M22 15V21M16 12V11.2C16 10.0799 16 9.51984 15.782 9.09202C15.5903 8.71569 15.2843 8.40973 14.908 8.21799C14.4802 8 13.9201 8 12.8 8H11.2C10.0799 8 9.51984 8 9.09202 8.21799C8.71569 8.40973 8.40973 8.71569 8.21799 9.09202C8 9.51984 8 10.0799 8 11.2V12M22 19V15.2C22 14.0799 22 13.5198 21.782 13.092C21.5903 12.7157 21.2843 12.4097 20.908 12.218C20.4802 12 19.9201 12 18.8 12H5.2C4.07989 12 3.51984 12 3.09202 12.218C2.71569 12.4097 2.40973 12.7157 2.21799 13.092C2 13.5198 2 14.0799 2 15.2V19H22Z"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				opacity="0.32"
				d="M20.75 8.65C20.75 6.40979 20.75 5.28969 20.314 4.43404C19.9305 3.68139 19.3186 3.06947 18.566 2.68597C17.7103 2.25 16.5902 2.25 14.35 2.25H9.65C7.40979 2.25 6.28969 2.25 5.43404 2.68597C4.68139 3.06947 4.06947 3.68139 3.68597 4.43404C3.25 5.28969 3.25 6.40979 3.25 8.65V12.25H20.75V8.65Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M8 9.2V11.25H16V9.2C16 8.0799 16 7.51984 15.782 7.09202C15.5903 6.71569 15.2843 6.40973 14.908 6.21799C14.4802 6 13.9201 6 12.8 6H11.2C10.0799 6 9.51984 6 9.09202 6.21799C8.71569 6.40973 8.40973 6.71569 8.21799 7.09202C8 7.51984 8 8.0799 8 9.2ZM1.46799 13.342C1.25 13.7698 1.25 14.3299 1.25 15.45V21.25C1.25 21.6642 1.58579 22 2 22C2.41421 22 2.75 21.6642 2.75 21.25V20.2C2.75 19.9515 2.95147 19.75 3.2 19.75H20.8C21.0485 19.75 21.25 19.9515 21.25 20.2V21.25C21.25 21.6642 21.5858 22 22 22C22.4142 22 22.75 21.6642 22.75 21.25V15.45C22.75 14.3299 22.75 13.7698 22.532 13.342C22.3403 12.9657 22.0343 12.6597 21.658 12.468C21.2302 12.25 20.6701 12.25 19.55 12.25H4.45C3.3299 12.25 2.76984 12.25 2.34202 12.468C1.96569 12.6597 1.65973 12.9657 1.46799 13.342Z"
				fill="currentColor"
			/>
		</Fragment>,
	],
]);
